module.exports = __webpack_public_path__ + "img/card-prov-remedy-req-management.9141a463.svg";